import { isEmptyArray } from "../../../utils/tests";

import { ITopScorers, ITopScorersRow } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from '../../../utils/errors';
import { isValidCompetitionTopScorers } from './typeguards';
import { CreateCompetitionScorersRankingInputSchema, CompetitionScorersRankingScorer } from 'appsync';
import { CompetitionScorersRankingQuery } from "../types";


const transformer = (obj: CompetitionScorersRankingQuery): ITopScorers => {
  if (isValidCompetitionTopScorers(obj)) {
    CreateCompetitionScorersRankingInputSchema().parse(obj.data?.getCompetitionScorersRanking, {reportInput: true});
    const { page, pages, scorers, competitionScorersUrl } = obj.data.getCompetitionScorersRanking;
    const pageNumber: number = Number(page);
    const isTopTen: boolean = page === 'top-ten' || isEmptyArray(pages);

    const mappedScorers = scorers?.map((scorer) => {

        const { playerPageLink, ...rest } = scorer as CompetitionScorersRankingScorer;

        return {
            areaIn: rest.areaIn,
            areaOut: rest.areaOut,
            goal: rest.goal,
            head: rest.head,
            logoUrl: rest.logoUrl,
            penalty: rest.penalty,
            playerName: rest.playerName,
            playerUrl: playerPageLink,
            position: rest.position,
        };
    });

    return {
        rows: mappedScorers as ITopScorersRow[],
        isTopTen,
        ctaLink: isTopTen ? competitionScorersUrl ?? undefined : undefined,
        pages: isTopTen
          ? undefined
          : {
              links: pages?.filter((page): page is string => page != null) ?? [],
              pageNumber,
            },
      };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CompetitionScorersRankingQuery object',
      data: obj
    });
  }
};

export default transformer;